export function SwitchModalState() {
	const modalButtons = document.querySelectorAll<HTMLButtonElement>('.js-moda-btn');
	const closeButtons = document.querySelectorAll<HTMLButtonElement>('.js-modal-close');

	modalButtons.forEach((button) => {
		button.addEventListener('click', () => {
			const modalId = button.getAttribute('aria-controls');
			if (!modalId) return

			const modal = document.getElementById(modalId);

			if (!(modal instanceof HTMLDialogElement)) return

			modal.showModal();

			const iframes = modal.querySelectorAll<HTMLIFrameElement>('iframe[data-src]');

			iframes.forEach((iframe) => {
				if (iframe.src) return;

				const src = iframe.dataset.src;

				if (!src) return;

				iframe.src = src;
			});

			button.setAttribute('aria-expanded', 'true');
		});
	});

	closeButtons.forEach((button) => {
		button.addEventListener('click', () => {
			const modal = button.closest('.js-modal-area');

			if (!(modal instanceof HTMLDialogElement)) return

			modal.close();

			const trigger = document.querySelector<HTMLButtonElement>(`[aria-controls="${modal.id}"]`);

			if (trigger) {
				trigger.setAttribute('aria-expanded', 'false');
				trigger.focus();
			}
		});
	});

	document.querySelectorAll('.js-modal-area').forEach((modal) => {
		if (!(modal instanceof HTMLDialogElement)) return

		modal.addEventListener('click', (event: MouseEvent) => {
			const rect = modal.getBoundingClientRect();
			const isInDialog = (
				rect.top <= event.clientY &&
				event.clientY <= rect.top + rect.height &&
				rect.left <= event.clientX &&
				event.clientX <= rect.left + rect.width
			);

			if (!isInDialog) {
				modal.close();

				const trigger = document.querySelector<HTMLButtonElement>(`[aria-controls="${modal.id}"]`);

				if (trigger) {
					trigger.setAttribute('aria-expanded', 'false');
				}
			}
		});
	});
}
